<div class="vehicle-form-container">
  <!-- Header -->
  <div *ngIf="showHeader" class="vehicle-form-title">
    <h5>{{ headerText }}</h5>
  </div>

  <!-- Vehicle Form -->
  <div class="vehicle-form">
    <div class="form-row">
      <!-- State Field -->
      <div class="form-field">
        <label class="field-label">State<span class="asterisk">*</span></label>
        <div class="select-wrapper p-custom-select">
          <mat-select
            class="form-select"
            [(ngModel)]="vehicleForm.state"
            (selectionChange)="onFormChange()"
          >
            <mat-option value="">Select State</mat-option>
            <mat-option *ngFor="let state of states" [value]="state.code">
              {{ state.name }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <!-- License Plate Field -->
      <div class="form-field">
        <label class="field-label">License Plate Number<span class="asterisk">*</span></label>
        <div class="input-wrapper">
          <input
            type="text"
            class="form-input"
            placeholder="e.g. UFC-37216"
            [(ngModel)]="vehicleForm.licensePlate"
            (input)="onFormChange()"
          />
          <button
            class="fetch-btn"
            (click)="onFetchVehicleDetails()"
            [disabled]="!canFetchVehicle || isLoadingVehicle"
          >
            <svg *ngIf="!isLoadingVehicle" width="20" height="20" viewBox="0 0 20 20" fill="white">
              <path
                d="M4.17 6.67L15.83 6.67M15.83 6.67L11.67 2.5M15.83 6.67L11.67 10.83"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div *ngIf="isLoadingVehicle" class="loading-spinner"></div>
          </button>
        </div>
      </div>
    </div>

    <!-- Help Text -->
    <p class="help-text" *ngIf="!vehicleData">
      Add the state & license plate number and click the arrow to fetch vehicle details.
    </p>

    <!-- Error Message -->
    <div *ngIf="vehicleErrorMessage" class="error-message">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M8 1.33333C4.32 1.33333 1.33333 4.32 1.33333 8C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33333 8 1.33333ZM8.66667 11.3333H7.33333V10H8.66667V11.3333ZM8.66667 8.66667H7.33333V4.66667H8.66667V8.66667Z"
          fill="#E53E3E"
        />
      </svg>
      <span>{{ vehicleErrorMessage }}</span>
    </div>

    <!-- Success Message -->
    <div *ngIf="vehicleData && !vehicleErrorMessage" class="details-fetched-text p6">
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.91602 1.9486C10.7958 2.45659 11.5277 3.18557 12.0392 4.06335C12.5508 4.94114 12.8241 5.9373 12.8323 6.95321C12.8406 7.96913 12.5833 8.96957 12.086 9.8555C11.5888 10.7414 10.8687 11.4821 9.99724 12.0043C9.12574 12.5264 8.13298 12.8119 7.11724 12.8325C6.1015 12.853 5.098 12.6079 4.20609 12.1215C3.31418 11.635 2.56477 10.9241 2.03207 10.059C1.49937 9.19389 1.20184 8.20468 1.16893 7.18926L1.16602 7.00026L1.16893 6.81126C1.2016 5.80384 1.49475 4.82207 2.01981 3.96168C2.54486 3.10128 3.2839 2.39161 4.16487 1.90186C5.04584 1.41211 6.03868 1.15899 7.0466 1.16718C8.05452 1.17538 9.04312 1.44459 9.91602 1.9486ZM9.16177 5.42118C9.06132 5.32074 8.92768 5.26041 8.78591 5.25149C8.64415 5.24258 8.504 5.2857 8.39177 5.37276L8.33693 5.42118L6.41602 7.34151L5.66177 6.58785L5.60693 6.53943C5.49469 6.45243 5.35457 6.40936 5.21283 6.4183C5.0711 6.42724 4.9375 6.48758 4.83709 6.588C4.73667 6.68842 4.67633 6.82202 4.66739 6.96375C4.65845 7.10548 4.70151 7.2456 4.78852 7.35785L4.83693 7.41268L6.0036 8.57935L6.05843 8.62776C6.16073 8.70713 6.28653 8.75021 6.41602 8.75021C6.5455 8.75021 6.6713 8.70713 6.7736 8.62776L6.82843 8.57935L9.16177 6.24601L9.21018 6.19118C9.29725 6.07894 9.34036 5.9388 9.33145 5.79703C9.32254 5.65527 9.2622 5.52163 9.16177 5.42118Z"
          fill="#079271"
        />
      </svg>
      Details Fetched
    </div>

    <!-- Manual Vehicle Entry Fields - Shown when vehicle not found error occurs -->
    <div *ngIf="showVehicleFields && !vehicleData" class="manual-vehicle-fields">
      <div class="form-row form-row-make-model">
        <div class="form-field">
          <label class="field-label">Make<span class="asterisk">*</span></label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="manualMake"
            (input)="onMakeInput()"
            placeholder="e.g. Toyota"
            [disabled]="isCreatingVehicle"
            maxlength="50"
          />
          <div class="error-message" *ngIf="manualMakeError">
            {{ manualMakeError }}
          </div>
        </div>
        <div class="form-field">
          <label class="field-label">Model<span class="asterisk">*</span></label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="manualModel"
            (input)="onModelInput()"
            placeholder="e.g. Camry"
            [disabled]="isCreatingVehicle"
            maxlength="50"
          />
          <div class="error-message" *ngIf="manualModelError">
            {{ manualModelError }}
          </div>
        </div>
      </div>
      <div class="form-row form-row-year">
        <div class="form-field form-field-year">
          <label class="field-label">Year<span class="asterisk">*</span></label>
          <input
            type="text"
            class="form-control"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="off"
            [(ngModel)]="manualYear"
            (keydown)="onYearKeydown($event)"
            (paste)="onYearPaste($event)"
            (input)="onYearInput()"
            placeholder="e.g. 2020"
            [disabled]="isCreatingVehicle"
            maxlength="4"
          />
          <div class="error-message" *ngIf="manualYearError">
            {{ manualYearError }}
          </div>
        </div>
      </div>
      <div class="manual-vehicle-actions">
        <button
          type="button"
          class="btn btn-primary btn-medium"
          [ngClass]="{ disabled: !isManualVehicleFormReady }"
          [disabled]="!isManualVehicleFormReady"
          (click)="onCreateVehicleManually()"
        >
          <span *ngIf="!isCreatingVehicle">{{ isEditMode ? 'Apply details' : 'Add Vehicle' }}</span>
          <span *ngIf="isCreatingVehicle">Creating...</span>
        </button>
      </div>
    </div>

    <!-- Vehicle Details Section - Only shown when vehicle is fetched -->
    <div *ngIf="vehicleData && !vehicleErrorMessage" class="vehicle-details">
      <div class="form-field">
        <label class="field-label">Vehicle</label>
        <input
          type="text"
          class="form-control"
          disabled
          [value]="vehicleData.year + ' ' + vehicleData.make + ' ' + vehicleData.model"
          placeholder="Vehicle details will appear here"
        />
      </div>

      <div class="form-row">
        <div class="form-field">
          <label class="field-label">Year</label>
          <input
            type="text"
            class="form-control"
            disabled
            [value]="vehicleData.year"
            placeholder="Year"
          />
        </div>
        <div class="form-field">
          <label class="field-label">Make</label>
          <input
            type="text"
            class="form-control"
            disabled
            [value]="vehicleData.make"
            placeholder="Make"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label class="field-label">Model</label>
          <input
            type="text"
            class="form-control"
            disabled
            [value]="vehicleData.model"
            placeholder="Model"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Booking Checkbox/Radio -->
  <div *ngIf="!showSaveCancelButtons && showBookingCheckbox" class="booking-checkbox">
    <label class="checkbox-label">
      <input
        [type]="isRadioButton ? 'radio' : 'checkbox'"
        [name]="isRadioButton ? 'vehicleBooking' : ''"
        [checked]="isBookingChecked"
        [disabled]="isBookingDisabled"
        (change)="onBookingChange($event)"
        class="checkbox-input"
      />
      <span class="checkbox-text">Book the car wash for this vehicle</span>
    </label>
  </div>
</div>
